<template>
	<div id="load" :class="{'no-bg': !isSiteStatusCalled && !$siteSettings?.data}" v-if="globalLoader || !isSiteStatusCalled">
        <div id="load-inner"><i class="fa fa-spinner fa-spin"></i></div>
    </div>
	<template v-if="isSiteStatusCalled">
		<router-view v-if="$route.name == 'PageNotFound'"></router-view>
		<div v-else>
		<div data-bs-toggle="modal" data-bs-target="#notification-alert" ref="notifyMe">
		</div>
		<NotificationAlert @allowNotifications="allowNotifications" @cancelNotifications="cancelNotifications"/>
		<div id="mySidenav" class="sidenav" :class="{ 'nav-left': isSideNav }">
		<div class="close-sidebar-menu">
			<SideMenu @close-side-nav="closeSideNav()" />
		</div>
		</div>	

		<div id="myAcnav" class="sidenav myAcnav" :class="{ 'ac-right': isMobileSideBar }">
			<MobileSiderBar @close-mobile-sidebar="toggleSideBar" />
		</div>

		<div id="body-outer" :class="{ 'nav-body': isSideNav, 'ac-body': isMobileSideBar }">
			<div class="overlay-body" @click="handleNoScroll()"></div>
				<template v-if="!underMaintenance">
					<template v-if="checkForHeaderShow()">
						<Header @open-side-nav="toggleSideMenu" @open-mobile-sidebar="toggleSideBar" v-if="$route.name != 'NotFound'"></Header>
					</template>
				</template>
				<main class="main-content" :class="$route.name=='sports-event-detail' && eventDetailHideSections && eventDetailHideSections.includes('show_full_screen') ? 'py-0': ''" @click="clearSearchResults()">           
				<router-view v-if="$siteSettings && $siteSettings?.data" />
				</main> 
				<div class="footer-main" v-if="$route.name == 'Home' && !underMaintenance">
					<Footer></Footer>
				</div>
			</div>
		</div>
		<div v-if="successMsg" :class="{ show: successMsg }" class="toster-wrapper" style="z-index: 9999999999999999;"
			ref="successmodal" id="successfullyModal">
			<SuccessModal :message="successMsg" />
		</div>
		<div v-if="errorMsg" :class="{ show: errorMsg }" style="z-index: 9999999999999999;" class="toster-wrapper"
			id="wrongtoaster">
			<ErrorModal :message="errorMsg" />
		</div>
	
		<!-- <Offers/> -->
	</template>
  	<AndroidBanner/>
</template>

<script>
import axios from 'axios';
import { AUTH_TOKEN } from  './shared/constants/cookies-const';
import { setHeaders } from '@/shared/services/headers';
import { mapGetters } from 'vuex';
import { defineAsyncComponent } from 'vue';
import notificationAlert from '@/shared/services/notificationAlert';
import { isApp as checkIsApp } from '@/shared/services/checkPlatform'

export default {
	name: 'App',
	extends: notificationAlert,
	components: {
			Header: defineAsyncComponent(() =>
				import('./shared/components/header/Header.vue')
			),
			SideMenu: defineAsyncComponent(() =>
				import('./shared/components/header/SideMenu.vue')
			),
			Footer: defineAsyncComponent(() =>
					import('./shared/components/footer/Footer.vue')
			),
			MobileSiderBar: defineAsyncComponent(() =>
					import('./shared/components/header/MobileSiderBar.vue')
			),
			SuccessModal: defineAsyncComponent(() =>
					import('@/shared/components/modal/SuccessModal.vue')
			),
			ErrorModal: defineAsyncComponent(() =>
					import('@/shared/components/modal/ErrorModal.vue')
			),
			NotificationAlert: defineAsyncComponent(() =>
					import('./shared/components/modal/NotificationAlert.vue')
			),
			AndroidBanner :defineAsyncComponent(() =>
			import('@/shared/components/header/AndroidBanner.vue')),
			
		},
		data() {
			return {
			isSideNav: false,
					isMobileSideBar: false,
					onLine: navigator.onLine,
					showBackOnline: false,
					interval:null,
			isSiteStatusCalled: false,
            isApp : false

			}
		},
		computed: {
			...mapGetters(['eventDetailHideSections','successMsg', 'errorMsg', 'siteVersion','underMaintenance','globalLoader','stateUser']),
			routePath() {
				return this.$route.name
			},
			domainName() {
				return this.$store.getters.domainName;
			},
			logInData() {
				return this.$store.getters?.logInData
			},
		},
		async  created(){
			this.getSiteVersion();
			if (this.$siteSettings?.data?.front_css != null && this.$siteSettings?.data?.front_css != '') {// Create a style element
				const styleElement = document.createElement('style');
				styleElement.type = 'text/css';
				styleElement.appendChild(document.createTextNode(this.$siteSettings.data.front_css));
				document.head.insertAdjacentElement('beforeend', styleElement);
			}
		},
		beforeUnmount() {
			clearInterval(this.interval);
		},
		mounted() {
		    this.isApp = checkIsApp()
            if(!this.isApp) this.interval = setInterval(this.checkModalStatus(), 60 * 1000);
			window.store = this.$store;
			window.cookies = this.$cookies;
			window.router = this.$router;
			window.authorization_token = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`
			setHeaders();  
			//checking internet connection
			window.addEventListener('online', this.updateOnlineStatus);
			window.addEventListener('offline', this.updateOnlineStatus);
			this.$errorToast(null);
			this.$successToast(null);
			// this.socketAllEvents();
		},
	methods: {
		checkModalStatus() {
            const modalEl = document?.getElementById('andriodposter');
			const isOpen = modalEl?.classList?.contains('show');
			if(isOpen) return
			const lastClosed = localStorage.getItem("modalClosedAt");
			const now = Date.now();

			if (!lastClosed || now - lastClosed >= 6 * 60 * 60 * 1000) {
			if(this.$siteSettings?.data?.poster?.filter(s => s?.poster_type == 13)?.length && !this.underMaintenance && this.$store?.getters?.androidclose){
				setTimeout(() => {
					this.$helper.openModal("#andriodposter");
				}, 500);
        }
			}
		},
		androidPosterOpenPopUp(){
			// check if the modal already open
			const modalEl = document?.getElementById('andriodposter');
			const isOpen = modalEl?.classList?.contains('show');
			if(!isOpen && !this.isApp && this.$siteSettings?.data?.poster?.filter(s => s?.poster_type == 13)?.length && !this.underMaintenance && !this.$store.getters?.androidclose){
			setTimeout(() => {
				this.$helper.openModal("#andriodposter");
			}, 500);
			}
		},
		toggleSideMenu(){
			if(this.isSideNav){
				this.isSideNav = false;
				document.body.classList.remove('overflow-body');
			}
			else{
				this.isSideNav = true;
				document.body.classList.add('overflow-body');
			}
		},
		handleNoScroll(){
			if(this.isMobileSideBar){
				this.isMobileSideBar = false;
				document.body.classList.remove('overflow-body');
			}
			if(this.isSideNav){
				this.isSideNav = false;
				document.body.classList.remove('overflow-body');
			}
		},
		toggleSideBar(){
			if(this.isMobileSideBar){
				this.isMobileSideBar = false;
				document.body.classList.remove('overflow-body');
			}
			else{
				this.isMobileSideBar = true;
				document.body.classList.add('overflow-body');
			}
		},
		getSiteVersion() {
				this.$apiCall('get', 'GET_SITE_VERSION', null, 'user', { domain: window.location.hostname }).then(async response => {
					if (response && response.status == 200) {
						if (response?.data?.status === 0) {
							this.$errorToast(response.data.debug[0]);
						} else {
							let resData = response.data.data;
							let currentVersion = resData.version;
							let userSystemVersion = this.siteVersion || 0;
							if (!userSystemVersion || currentVersion != userSystemVersion || !this.$siteSettings.data) {
								this.$store.dispatch('setSiteVersion', currentVersion);
								this.getSiteSettingsServiceCall();
							} else {
								this.setSiteSttings(this.$siteSettings.data);
							}

							if (resData.maintenance) {
								const { from_date, to_date } = resData.maintenance;
								const fromDateTime = new Date(from_date).getTime();
								const toDateTime = new Date(to_date).getTime();
								const currentDateTime = Date.now();

								const isInMaintenanceWindow = fromDateTime <= currentDateTime && currentDateTime <= toDateTime;

								if (fromDateTime && toDateTime && isInMaintenanceWindow) {
									this.$store.dispatch('setUnderMaintenance', resData.maintenance);
									this.$router.push({ name: 'Maintenance' });
								}
							}
							else {
								if(this.underMaintenance) {
									this.$router.push({name:'Home'});
								}
								this.$store.dispatch('setUnderMaintenance', null); 
							}
						}
					}
				}).catch(error => {
					if (error) {
						this.$errorToast(error[0]);
					}
				});
			},
		getSiteSettingsServiceCall() {
				this.$apiCall('get', 'GET_SITE_SETTINGS', null, 'user', { domain: window.location.hostname }).then(async response => {
					if (response && response.status == 200) {
						if (response?.data?.status === 0) {
							this.$errorToast(response.data.debug[0]);
						} else {
							let resData = response?.data.data;
							resData.siteSetting.announcement = JSON.parse(resData.siteSetting.announcement)
							resData.siteSetting.offer = resData.siteSetting.poster.find( pos => pos.poster_type == 12);
							let casino;
							if(resData?.casino_url) {
								const getCasinoGame = async () => {
									let gameResp = await axios.get(resData.casino_url)
									return gameResp.data
								};
								casino = await getCasinoGame();
							} else {
								casino = resData?.casino_url
							}
							resData.siteSetting.provider_currency = resData.siteSetting.provider_currency.reduce((a,b) =>{
								a[b.provider_id] = b.currency
								return a;
							}, {})		
							this.$store.dispatch('setSettings', resData.siteSetting);
							this.$store.dispatch('setGamesData', casino);
							this.$store.dispatch('setBonusData', resData.bonus_data);
							this.setSiteSttings(resData.siteSetting);
						}
					}
				}).catch(error => {
					if (error) {
						this.$errorToast(error[0]);
					}
				});
			},

			setSiteSttings(siteData) {
				if (siteData.languagesList) {
					this.$setCurrentLangData(siteData.languagesList, siteData.language_code, siteData.aws_url)
					this.$store.dispatch('setLanguagesData', siteData.languagesList);
				}

				this.$store.dispatch('setSettings', siteData);
				this.setManifest(siteData);
				if(siteData?.meta_pixel_code) {
					this.addFacebookPixel(siteData?.meta_pixel_code);
				}
				// Create FAVICON
				const favElement = document.createElement('link');
				favElement.rel = 'icon';
				favElement.href = siteData.aws_url + siteData.storage_path.domain_image + siteData.fav_logo;
				document.head.insertAdjacentElement('beforeend', favElement);
				document.text = siteData?.site_title ? siteData?.site_title : siteData?.domain_name;
				if (this.$auth.status) {
					this.getWalletBalance();
				}
				if(siteData.meta_tags) {
					document.head.innerHTML += siteData.meta_tags;
				};
				if(siteData.g_tags) {
					this.setGoogleAnalyticsTag(siteData.g_tags);
				};
				if(siteData.site_map) {
					const sitemapLink = document.createElement("link");
					sitemapLink.rel = "sitemap";
					sitemapLink.type = "application/xml";
					sitemapLink.title = "Sitemap";
					sitemapLink.href = siteData.aws_url + siteData.storage_path.site_map + siteData.site_map;
					document.head.appendChild(sitemapLink);
				};

				try {
					if (siteData.front_css != null && siteData.front_css != '') {// Create a style element
						const styleElement = document.createElement('style');
						styleElement.type = 'text/css';
						styleElement.appendChild(document.createTextNode(siteData.front_css));
						document.head.insertAdjacentElement('beforeend', styleElement);
					}
				}
				catch (error) {
					console.log("ERROR 1: ", error);
				}
				this.isSiteStatusCalled = true;
				this.callNotificationPermissionAfterLogin();
				setTimeout(() => {
					this.callOfferPage();
				},1000);
				setTimeout(() => {
					this.androidPosterOpenPopUp(); 	
				}, 500);

			},
			setGoogleAnalyticsTag(gTag) {
				let script1 = document.createElement('script');
				script1.async = true;
				script1.src = `https://www.googletagmanager.com/gtag/js?id=${gTag}`;
	
				let script2 = document.createElement('script');
				script2.innerHTML = `
					window.dataLayer = window.dataLayer || [];
					function gtag(){dataLayer.push(arguments);}
					gtag('js', new Date());
					gtag('config', '${gTag}');
				`;
	
				document.head.appendChild(script1);
				document.head.appendChild(script2);
			},
			setManifest(resData) {
				let manifestName = resData.domain_name.charAt(0).toUpperCase() + resData.domain_name.slice(1).toLowerCase();
				var dynamicManifest = {
					name: manifestName,
					short_name: manifestName,
					start_url: window.location.origin,
					display: 'standalone',
					icons: [{
						src: resData.app_logo ? resData.aws_url + resData.storage_path.domain_image + resData.app_logo : resData.aws_url + resData.storage_path.domain_image + resData.fav_logo,
						sizes: "256x256 512x512 192x192 144x144",
						type: "image/png",
						purpose: 'any'
					}]
				}

				// Manifest Blob
				const stringManifest = JSON.stringify(dynamicManifest);
				const blob = new Blob([stringManifest], { type: 'application/json' });
				const manifestURL = URL.createObjectURL(blob);

				// Manifest Creation
				const favElement = document.createElement('link');
				favElement.rel = 'manifest';
				favElement.href = manifestURL;
				document.head.insertAdjacentElement('beforeend', favElement);

				// IOS APK Logo
				let logo = resData.aws_url + resData.storage_path.domain_image + resData.logo;
				document.querySelector('#appleIcon').setAttribute('href', logo);
				document.querySelector('#appleLaunchIcon').setAttribute('href', logo);

				// IOS App title
				const metaTag = document.createElement('meta');
				metaTag.setAttribute('name', 'apple-mobile-web-app-title');
				metaTag.setAttribute('content', manifestName);
				document.head.insertAdjacentElement('beforeend', metaTag);

			},
		cancelOneClick(){
		this.$store.dispatch('setIsClickBetOn', false);
		},
		getWalletBalance() {
				this.$apiCall('post', 'WALLET_BALANCE').then(response => {
					if (response && response.status == 200 && response.data) {
						let user = this.$store.getters.stateUser;
						user.balance = response.data.bl;
						user.expl = response.data.ex;
						user.bets_count = response.data.bc;
						user.earnBonus = response?.data.eb;
						this.$store.dispatch('setUser', user);
						// if ((user.exp - this.$dateTime.currentTimestamp()) < 10) {
						// 	this.refreshAuthToken();
						// } else {
							setTimeout(function () {
								this.getWalletBalance();
							}.bind(this), 2000);
						// }
					} else {
						this.$cookies.keys().forEach(cookie => this.$cookies.remove(cookie))
						this.$store.dispatch('resetAllState');
					}
				}).catch(error => {
					if (error) {
						console.log(error);
						this.$errorToast(error[0]);
					}
				});
			},
		refreshAuthToken(refresh = false) {
				this.$apiCall('post', 'AUTH_REFRESH').then(response => {
					let user = this.$store.getters.stateUser;
					user.token = response.data.data.token;
					user.exp = response.data.data.exp;
					this.$cookies.set(AUTH_TOKEN, response.data.data.token);
					this.$store.dispatch('setToken', `Bearer ${response.data.data.token}`);
					window.authorization_token = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`;
					//for add on all APIs
					axios.defaults.headers.common['Authorization'] = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`;
					this.$store.dispatch('setUser', user);
					this.refreshInit = false;
					if (refresh) {
						router.go();
					}
				}).catch(error => {
					if (error) {
						this.$errorToast(error[0]);
					}
					this.refreshInit = false;
				});
			},

		closeSideNav() {
			if (this.isSideNav){
				this.isSideNav = false;
				document.body.classList.remove('overflow-body');
			}
		},
		updateOnlineStatus(e) {
		const {
			type
		} = e;
		this.onLine = type === 'online';
		},
		checkForHeaderShow() {
				if (this.routePath == 'search') {
					return false;
				} else if (this.eventDetailHideSections && this.eventDetailHideSections.includes('show_full_screen') && this.routePath == 'sports-event-detail') {
					return false;
				} else {
					return true;
				}
			},
			callNotificationPermissionAfterLogin(){
				if (this.$auth.status) {
					if (this.$store.getters.stateUser.notificationUnsubscribed == 1) {
						return;
					}
					if (this.$store.getters.stateUser.notificationSubscribed != 1) {
						this.requestNotificationPermission()
					}
				}
			},
			callOfferPage(){
				if((this.logInData.logInWithMobile || !this.logInData.logInWithMobile ) && this.logInData.userIds.includes(this.$auth?.user?.userid)) {
					let is_offer = localStorage.getItem("is_offer");
					if (this.$auth.status && this.$siteSettings.data.offer != null && is_offer == null && this.$siteSettings?.data?.business_type == 2) {
						setTimeout(()=>{
							this.$helper.openModal("#offer_pop_up");
						},500)
					}
				}
			},
			clearSearchResults() {
				// Programmatically click the button using its ID
				const searchClearBtn = document.getElementById('searchResultsCloseBtn');
				if (searchClearBtn) {
					searchClearBtn.click();
				}
			},
			addFacebookPixel(pixelId) {
				const script = document.createElement('script');
				script.innerHTML = `
					!function(f,b,e,v,n,t,s)
					{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					n.queue=[];t=b.createElement(e);t.async=!0;
					t.src=v;s=b.getElementsByTagName(e)[0];
					s.parentNode.insertBefore(t,s)}(window, document,'script',
					'https://connect.facebook.net/en_US/fbevents.js');
					fbq('init', '${pixelId}');
					fbq('track', 'PageView');
				`;
				document.head.appendChild(script);

				// Add the noscript image
				const noscript = document.createElement('noscript');
				noscript.innerHTML = `
					<img height="1" width="1" style="display:none"
						src="https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1"/>
				`;
				document.head.appendChild(noscript);
		},
	},
	watch: {
		onLine(v) {
		if (v) {
			this.showBackOnline = true;
			setTimeout(() => {
			this.showBackOnline = false;
			}, 1000);
		}
		},
	}
}
</script>